import { render, staticRenderFns } from "./GptWelcome.vue?vue&type=template&id=aab79954"
import script from "./GptWelcome.vue?vue&type=script&lang=ts"
export * from "./GptWelcome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports